/* eslint-disable camelcase */
import maxValueFormatted from './maxValueFormatted';

export default {
  maxValueFormatted
};
